import { createWebHistory, createRouter } from "vue-router";

import TransactionsIndexView from "@/components/Transactions/IndexView.vue";
import WeeklyOutlooksIndexView from "@/components/WeeklyOutlooks/IndexView.vue";
import AccountsIndexView from "@/components/Accounts/IndexView.vue";
import BankingInstitutionsIndexView from "@/components/BankingInstitutions/IndexView.vue";
import BudgetTemplatesIndexView from "@/components/Budget/BudgetTemplates/IndexView.vue";
import BudgetTemplatesCreateView from "@/components/Budget/BudgetTemplates/CreateView.vue";
import BudgetTemplatesEditView from "@/components/Budget/BudgetTemplates/EditView.vue";
import BudgetTrackingIndexView from "@/components/Budget/BudgetTracking/IndexView.vue";
import MonthlyOverviewIndexView from "@/components/MonthlyOverview/IndexView.vue";

const routes = [
  { path: "/", redirect: "/weekly-outlooks" },
  { path: "/monthly-overview", component: MonthlyOverviewIndexView },
  { path: "/weekly-outlooks", component: WeeklyOutlooksIndexView },
  { path: "/transactions", component: TransactionsIndexView },
  { path: "/accounts", component: AccountsIndexView },
  {
    path: "/banking-institutions",
    component: BankingInstitutionsIndexView,
  },
  {
    path: "/budget",
    redirect: "/budget/templates",
  },
  {
    path: "/budget/templates",
    component: BudgetTemplatesIndexView,
  },
  {
    path: "/budget/templates/create",
    component: BudgetTemplatesCreateView,
  },
  {
    path: "/budget/templates/:templateUid/edit",
    component: BudgetTemplatesEditView,
  },
  {
    path: "/budget/tracking",
    component: BudgetTrackingIndexView,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
